import { Component, Vue } from "vue-property-decorator";
import { apiService } from "@services/api.service";

@Component({})
export default class RegistrationMixin extends Vue {
  public participationCallFailed: boolean = false;
  public event?: Events.Event = {
    id: 0,
    headline: "",
    event_date: "",
    event_end_date: "",
    event_url: "",
    logo: "",
    participationState: "loading",
    moderators: [],
    company_profiles: [],
  };

  public async getUserParticipation(event: Events.Event): Promise<Events.Event> {
    if (event.external_event !== undefined && !event.external_event) {
      event.participationState = "not_participating";
      this.participationCallFailed = true;
      return event;
    } else if (!this.$user.signedIn) {
      event.participationState = "not_participating";
      return event;
    }

    try {
      const response = await apiService.social_events.userIsRegistered(event.id);
      event.participationState = response.data.registered ? "participating" : "not_participating";
    } catch (error: any) {
      if (error.response?.status !== 422 && error.response?.status !== 403) {
        apiService.handleAPIError(error);
      } else {
        event.participationState = "not_participating";
        this.participationCallFailed = true;
        console.warn(`event ${event.id} does not meet prerequisites to be registrable.`);
      }
    }
    return event;
  }
}
